"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddToBasketErrors = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Message = require("../message/Message");
var _Modal = require("../modal/Modal");
var _addToBasketErrorsModule = _interopRequireDefault(require("./add-to-basket-errors.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var AddToBasketErrors = exports.AddToBasketErrors = function AddToBasketErrors(_ref) {
  var errors = _ref.errors,
    clearAddToBasketErrors = _ref.clearAddToBasketErrors,
    _ref$showAsWarnings = _ref.showAsWarnings,
    showAsWarnings = _ref$showAsWarnings === void 0 ? false : _ref$showAsWarnings;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal, {
    className: _addToBasketErrorsModule.default['add-to-basket-errors'],
    footer: false,
    isOpen: true,
    onClose: clearAddToBasketErrors,
    title: "Something went wrong",
    children: errors.map(function (_ref2) {
      var message = _ref2.message,
        code = _ref2.code;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Message.Message, {
        title: message,
        type: showAsWarnings ? 'warning' : 'error'
      }, code);
    })
  });
};
AddToBasketErrors.propTypes = {
  errors: _propTypes.default.arrayOf(_propTypes.default.shape({
    message: _propTypes.default.string.isRequired,
    code: _propTypes.default.string.isRequired
  })).isRequired,
  clearAddToBasketErrors: _propTypes.default.func,
  showAsWarnings: _propTypes.default.bool
};